import { memo } from 'react';
import { useTheme } from '@simplywallst/ui-core';

interface Props {
  tickerSymbol: string;
  y: number;
  chartWidth: number;
  letterWidth?: number;
  condensed?: boolean;
  liftUp?: boolean;
}

const UnprofitableLabel = memo(
  ({
    tickerSymbol,
    y = 0,
    chartWidth,
    letterWidth = 8,
    condensed,
    liftUp = false,
  }: Props) => {
    const theme = useTheme();
    const label = condensed
      ? 'is unprofitable'
      : `${tickerSymbol} is unprofitable`;
    const labelLength = label.length * letterWidth + 16;

    return (
      <g transform={`translate(0, ${liftUp ? -36 : 0})`}>
        <rect
          rx="2"
          x={chartWidth - labelLength}
          y={y - (condensed ? 52 : 36)}
          fill={theme.color.darkGray}
          width={labelLength}
          height={condensed ? 41 : 25}
        />
        <text
          x={chartWidth + 9 - labelLength}
          y={y - 19}
          fill={theme.color.white}
          fontWeight={600}
          fontSize={13}
        >
          {label}
        </text>
        {condensed && (
          <text
            x={chartWidth + 9 - labelLength}
            y={y - 35}
            fill={theme.color.white}
            fontWeight={600}
            fontSize={13}
          >
            {tickerSymbol}
          </text>
        )}
      </g>
    );
  }
);
export default UnprofitableLabel;
